import React from 'react';

import { TeacherPersonalDataTableProps } from '../../../../utils/interfaces';
import { TeacherPersonalDataTable } from '../PersonalData/PersonalDataTable';

import './TeacherPersonalData.css';

const TeacherPersonalData: React.FC<TeacherPersonalDataTableProps> = ({
  apiService,
  data,
}) => {
  return (
    <div className="teacherpersonaldata__general">
      <TeacherPersonalDataTable data={data} apiService={apiService} />
    </div>
  );
};

export default TeacherPersonalData;
